import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { LocalAtendimento, AgendamentoCirurgia, AgendamentoMedico, ModalSolicitacaoPendencia, StatusCirurgiaEnum, Pendencia, PendenciaMensagem, TipoDocumentoUpload, TipoEnvioMensagemEnum, ModeloCirurgia } from '@/types/_'
import Apis from '@/Apis/_'
import ResponseApi from '@/types/interfaces/FactoryResponse'
import { Acoes, MotivoRecusaDoOrcamento, SituacaoData } from '@/types/interfaces/Solicitacao'
import { PendenciaSolicitacao } from '@/types/core'
import { timeout } from '@/utils/common'


@Module({ namespaced: true, name: 'SolicitacaoPendenciaStore' })
export default class SolicitacaoPendenciaStore extends VuexModule {
  public modalSolicitacaoPendencia: ModalSolicitacaoPendencia = {
    agendamentoPendencia: false,
    agendamentoConfirmar: false,
    pendencia: false,
    confirmar: false,
    autorizacao: false,
    autorizacaoConfirmar: false,
    autorizacaoPendencia: false,
    encerrarPendenciaAgendamento: false,
    encerrarPendenciaAutorizacao: false,
  }

  pendencia: Pendencia = {
    id: '',
    solicitacaoId: '',
    mensagens: [],
  }

  agendamentoMedico: AgendamentoMedico = {
    carater: {
      display: '',
      key: '',
    },
    configuracoes: {
      prazoEmDiasParaTriagem: 0,
      prazoMaximoEmDiasParaAgendamento: 0,
    },
    dataAgendamentoVirtual: false,
    dataAgendamento: '',
    etapa: {
      display: '',
      key: '',
    },
    hospitalId: '',
    id: '',
    nomeMedico: '',
    paciente: '',
    procedimento: '',
    situacao: {
      display: '',
      key: '',
    },
    situacaoData: {
      display: '',
      key: '',
    },
    template: '',
    hospital: '',
    dataAutorizada: {
      data: '',
      hora: '',
    },
    numeroAgendamento: '',
    protocoloOperadora: '',
    acoes: {
      editar: false,
      podeResolverPendencia: false,
      aceitarAutorizacaoParcial: false,
      criarContestacao: false,
      responderContestacao: false,
      solicitarCancelamento: false,
      visualizarContestacao: false,
      visualizarItensAutorizados: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      alterarData: false,
      analizarResposta: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      agendamentoAtualizaTriagem: false,
      visualizar: false,
      visualizarPendencia: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoFazAnalisePosCotacao: false,
      autorizacaoResolvePendenciaRoboAutorizacao: false,
      autorizacaoFazRetornoParaCotacao: false,
      autorizacaoAutorizaNegociacaoParticular: false,
      agendamentoFazReservaDeSalaParticular: false,
      agendamentoInformaReservaEmSolicitacaoParticular: false,
    },
    canceladoMotivo: {
      display: '',
      key: '',
    },
    url: '',
    urlNaoParticular: '',
    tempoCirurgia: 0,
    statusCirurgia: null,
    medicoSolicitanteId: '',
    convenioNome: '',
    localAtendimentoId: '',
    autorizacaoObservacao: '',
    autorizacaoValidade: '',
    laudos: [],
    temOpme: false,
    orcamentoParticular: '',
    dataAgendamentoMensagemBloqueio: '',
  }

  agendamentoCirurgiaDefault: AgendamentoCirurgia = {
    acoes: {
      agendamentoAtualizaTriagem: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      agendamentoRealizaTriagem: false,
      alterarData: false,
      analizarResposta: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoAlteraSolicitacaoAutorizada: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoSolicitaCancelamento: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      confirmarData: false,
      contatar: false,
      visualizar: false,
      visualizarPendencia: false,
    },
    carater: '',
    convenioId: '',
    convenioNome: '',
    dataAgendamento: '',
    dataAgendamentoVirtual: false,
    dataNascimento: '',
    dataProximoContato: '',
    dataSolicitacao: '',
    etapa: {
      display: '',
      key: '',
    },
    hospitalId: '',
    hospitalNome: '',
    id: '',
    medicoId: '',
    medicoNome: '',
    numeroAgendamento: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opme: '',
    pacienteNome: '',
    procedimentoPrincipalNome: '',
    situacao: {
      display: '',
      key: '',
      quantidade: 0,
    },
    situacaoData: '',
    tempoNoStatus: '',
    lembreteStatus: '',
  }

  agendamentoCirurgia: AgendamentoCirurgia = { ...this.agendamentoCirurgiaDefault }

  enviarPendencia: boolean = false
  acessoHospital: boolean = false
  tipoEnvioMensagem: string = ''
  encerrarPendenciaBtn: boolean = false
  visualizarPendencia: boolean = false

  pendenciaSolicitacao: PendenciaSolicitacao.IPendenciaSolicitacao = new PendenciaSolicitacao.PendenciaSolicitacao()

  private locaisAtendimentoDefault: LocalAtendimento[] = []
  private localAtendimentoDefault: LocalAtendimento = {
    id: '',
    ambulatorio: null,
    ativo: null,
    nome: '',
  }

  public locaisAtendimento: LocalAtendimento[] = [...this.locaisAtendimentoDefault]
  public localAtendimento: LocalAtendimento = { ...this.localAtendimentoDefault }
  public localAtendimentoId: string | null = ''
  public nomeCirurgia: string = ''

  @Action
  async atualizaLocalAtendimento(localAtendimentoId: string) {
    const params: any = {
      medicoId: this.agendamentoMedico.medicoSolicitanteId,
      solicitacaoId: this.agendamentoMedico.id,
      localAtendimentoId,
    }

    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.updateLocalAtendimento(params)
    if (request.success) {
      return true
    }

    return false
  }

  @Action
  async criarModeloCirurgia(params: any) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.criarModeloCirurgia(params)
    return request.success
  }

  @Action
  async sendMessageBackoffice() {
    const { solicitacaoId } = this.pendencia
    const { mensagens } = this.pendencia
    const request = await this.pendenciaSolicitacao.abrirMensagem(solicitacaoId, mensagens)
    return request as ResponseApi
  }

  @Action
  async enviarMensagem(pendenciaMensagem: PendenciaMensagem) {
    const pendencia: Pendencia = {
      id: this.pendencia.id,
      mensagens: [pendenciaMensagem],
      solicitacaoId: this.pendencia.solicitacaoId,
    }
    const { solicitacaoId } = pendencia

    const response = await this.pendenciaSolicitacao.sendEnviarMensagem(solicitacaoId, pendencia)
    if (response.success) {
      this.context.commit('setMensagem', pendenciaMensagem)
    }

    return response
  }

  @Action
  async getPendencias(solicitacaoId: string) {
    const request = await this.pendenciaSolicitacao.getMensagemAberta(solicitacaoId)

    if (request.success) {
      const pendencia: Pendencia = {
        id: request.data.pendenciaId,
        mensagens: request.data.mensagens,
        solicitacaoId,
      }

      this.context.commit('setPendencia', pendencia)
    }

    return request
  }

  @Action
  async encerrarPendencia() {
    const { solicitacaoId } = this.pendencia
    const request = await Apis.Agendamento
      .SolicitacaoPendenciaApi.encerrarPendencia(solicitacaoId)

    return request.success
  }

  @Action
  async uploadDocumento(param: any) {
    const request = await this.pendenciaSolicitacao.uploadDocumento(param)
    return request
  }

  @Action
  async setAgendamentoMedicoAndLocais(agendamentoMedico: AgendamentoMedico) {
    this.context.commit('setAgendamentoMedico', agendamentoMedico)
    this.context.commit('setLocalAtendimentoId', agendamentoMedico.localAtendimentoId)
    const req = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLocalAtendimentoByMedico(agendamentoMedico.medicoSolicitanteId, agendamentoMedico.hospitalId)
    if (req.success) {
      this.context.commit('setLocaisAtendimento', req.data)
    }
    return this.agendamentoMedico
  }

  @Mutation
  setNomeCirurgia(value: string) {
    this.nomeCirurgia = value
  }

  @Mutation
  clearNomeCirurgia() {
    this.nomeCirurgia = ''
  }

  @Mutation
  setMensagem(mensagem: PendenciaMensagem) {
    this.pendencia.mensagens.push(mensagem)
  }

  @Mutation
  setAgendamentoCirurgia(agendamento: AgendamentoCirurgia) {
    this.agendamentoCirurgia = agendamento
  }

  @Mutation
  setPendencia(pendencia: Pendencia) {
    this.pendencia = pendencia
  }

  @Mutation
  setModalAutorizacao(value: boolean) {
    this.modalSolicitacaoPendencia.autorizacao = value
  }

  @Mutation
  setModalAutorizacaoConfirmar(value: boolean) {
    this.modalSolicitacaoPendencia.autorizacaoConfirmar = value
  }

  @Mutation
  setModalSolicitacaoAgendamentoPendencia(value: boolean) {
    this.modalSolicitacaoPendencia.agendamentoPendencia = value
  }

  @Mutation
  setModalSolicitacaoAutorizacaoPendencia(value: boolean) {
    this.modalSolicitacaoPendencia.autorizacaoPendencia = value
  }

  @Mutation
  setModalSolicitacaoPendencia(value: boolean) {
    this.modalSolicitacaoPendencia.pendencia = value
  }

  @Mutation
  setModalSolicitacaoAgendamentoConfirmar(value: boolean) {
    this.modalSolicitacaoPendencia.agendamentoConfirmar = value
  }

  @Mutation
  setModalEncerrarPendenciaAgendamento(value: boolean) {
    this.modalSolicitacaoPendencia.encerrarPendenciaAgendamento = value
  }

  @Mutation
  setModalEncerrarPendenciaAutorizacao(value: boolean) {
    this.modalSolicitacaoPendencia.encerrarPendenciaAutorizacao = value
  }

  @Mutation
  setModalConfirmar(value: boolean) {
    this.modalSolicitacaoPendencia.confirmar = value
  }

  @Mutation
  setPendenciaMensagem(value: PendenciaMensagem) {
    this.pendencia.mensagens.push(value)
  }

  @Mutation
  setSolicitacaoId(solicitacaoId: string) {
    this.pendencia.solicitacaoId = solicitacaoId
  }

  @Mutation
  setSituacaoData(situacao: SituacaoData) {
    this.agendamentoMedico.situacaoData = situacao
  }

  @Mutation
  setAgendamentoMedico(agendamentoMedico: AgendamentoMedico) {
    this.agendamentoMedico = agendamentoMedico
    this.pendencia.solicitacaoId = agendamentoMedico.id || ''
  }

  @Mutation
  setEnviarPendencia(value: boolean) {
    this.enviarPendencia = value
  }

  @Mutation
  setAcessoHospital(value: boolean) {
    this.acessoHospital = value
  }

  @Mutation
  setTipoEnvioMensagem(tipoEnvio: TipoEnvioMensagemEnum) {
    this.tipoEnvioMensagem = tipoEnvio
  }

  @Mutation
  setEncerrarPendenciaBtn(value: boolean) {
    this.encerrarPendenciaBtn = value
  }

  @Mutation
  setVisualizarPendencia(value: boolean) {
    this.visualizarPendencia = value
  }

  @Mutation
  setAcoes(value: Acoes) {
    this.agendamentoMedico.acoes = value
  }

  @Mutation
  clearPendencia() {
    this.pendencia = {
      id: '',
      mensagens: [],
      solicitacaoId: '',
    }
    this.encerrarPendenciaBtn = false
    this.visualizarPendencia = false
  }

  @Mutation
  clearMensagem() {
    this.pendencia.mensagens = []
  }

  @Mutation
  setStatusCirurgia(value: StatusCirurgiaEnum | null) {
    this.agendamentoMedico.statusCirurgia = value
  }

  @Mutation
  setLocaisAtendimento(value: LocalAtendimento[]) {
    this.locaisAtendimento = value
  }

  @Mutation
  setLocalAtendimentoId(value: string | null) {
    this.localAtendimentoId = value
  }

  @Mutation
  setLocalAtendimento(value: LocalAtendimento) {
    this.localAtendimento = value
  }

  @Mutation
  clearLocaisAtendimento() {
    this.locaisAtendimento = [...this.locaisAtendimentoDefault]
  }

  @Mutation
  clearLocalAtendimento() {
    this.localAtendimento = { ...this.localAtendimentoDefault }
  }

  @Mutation
  clearLocalAtendimentoId() {
    this.localAtendimentoId = ''
  }

  @Action
  async deleteSolicitacao(id: string) {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteSolicitacao(id)
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  public modelosCirurgia: ModeloCirurgia[] = []
  public showModalAplicarModeloCirurgia: boolean = false
  public modeloCirurgiaId: string = ''

  @Mutation
  setModeloCirurgiaId(value: string) {
    this.modeloCirurgiaId = value
  }

  @Mutation
  setShowModalAplicarModeloCirurgia(value: boolean) {
    this.showModalAplicarModeloCirurgia = value
  }

  @Mutation
  setModelosCirurgia(data: ModeloCirurgia[]) {
    this.modelosCirurgia = data
  }

  @Mutation
  clearModelosCirurgia() {
    this.modelosCirurgia = []
  }

  @Action
  async getModeloCirurgia(params: any) {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getModeloCirurgia(
        params.hospitalId,
        params.medicoId,
        params.convenioId!,
        params.planoId!,
        params.localAtendimentoId!,
      )
      if (request.success) this.context.commit('setModelosCirurgia', request.data as ModeloCirurgia[])
      return request
    } catch (error) {
      this.context.commit('setModelosCirurgia', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async aplicarCirurgiaModelo() {
    try {
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.aplicarCirurgiaModelo({
        solicitacaoId: this.agendamentoMedico.id,
        modeloCirurgiaId: this.modeloCirurgiaId,
      })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  @Action
  async gerarPedidoSemAssinatura() {
    try {
      const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.gerarPedidoSemAssinatura({ solicitacaoId: this.agendamentoMedico.id })
      return request
    } catch (error) {
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }

  // Aprovar ou recusar orçamento...
  public modalAprovarOuRecusarOrcamento: boolean = false

  @Mutation
  setModalAprovarOuRecusarOrcamento(value: boolean) {
    this.modalAprovarOuRecusarOrcamento = value
  }

  public motivosDeRecusa: MotivoRecusaDoOrcamento[] = [
    {
      id: '967306e6-94e5-421b-be61-7ad6062fca29',
      descricao: 'Desistência por falta de interesse',
      hospitalId: '',
      status: 'Ativo',
    },
    {
      id: 'e874a99a-79ad-49ce-a9d4-2b9b32a34f38',
      descricao: 'Desistência da parte do paciente',
      hospitalId: '',
      status: 'Ativo',
    },
    {
      id: 'f63c518c-23e7-4449-8ad7-832134f18ddb',
      descricao: 'Cancelamento da cirugia',
      hospitalId: '',
      status: 'Ativo',
    },
    {
      id: '83fd9d25-9a24-477d-b8c0-3eecf84b7e4e',
      descricao: 'Médico não considera a cirurgia adequada',
      hospitalId: '',
      status: 'Ativo',
    },
    {
      id: 'dddb2d27-ce94-46e3-9a88-d49024f9d02a',
      descricao: 'A grana tá curta...',
      hospitalId: '',
      status: 'Ativo',
    },
    {
      id: '00000000-0000-0000-0000-000000000000',
      descricao: 'Outro motivo',
      hospitalId: '',
      status: 'Ativo',
    },
  ]

  @Mutation
  setMotivosDeRecusa(value: MotivoRecusaDoOrcamento[]) {
    this.motivosDeRecusa = value
    this.motivosDeRecusa.push({
      id: '00000000-0000-0000-0000-000000000000',
      descricao: 'Outro motivo',
      hospitalId: '',
      status: 'Ativo',
    })
  }

  @Mutation
  clearMotivosDeRecusa() {
    this.motivosDeRecusa = []
  }

  @Action
  async getMotivoDeRecusaDoOrcamentoByHospitalId(hospitalId: string = '') {
    try {
      const params: { hospitalId: string; status: string } = { hospitalId, status: 'Ativo' }
      const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getMotivoDeRecusaDoOrcamentoByHospitalId(params)
      if (request.success) this.context.commit('setMotivosDeRecusa', request.data as MotivoRecusaDoOrcamento[] || [])
    } catch (error) {
      this.context.commit('setMotivosDeRecusa', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
